import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { Fields } from '../../Fields';
import { FIELD_TYPES } from '../../../utils/utils';
import AddIcon from '@mui/icons-material/Add';
import PickIcon from '@mui/icons-material/RadioButtonUnchecked';
import UnPickIcon from '@mui/icons-material/RadioButtonChecked';
import DeleteIcon from '@mui/icons-material/Delete';
import { JSTextEdidor } from '../JSTextEdidor';
import JHApi from "../../../utils/JHApi"
import CoverLetterChanges from './CoverLetterChanges';
import EditIcon from '@mui/icons-material/Edit';
import SparklesIcon from '../../../assets/svgs/SparklesIcon';
import ReactGA from 'react-ga4'

export default function CoverLetterManager(props) {
    const isLoading = props.isLoading || false
    const journeyData = props.journeyData || {} 

    const isAdmin = props.isAdmin
    const userId = props.userId

    const isApply = props.isApply || false

    const defCoverLetters = journeyData.coverLetter ? [{title:'Cover Letter 1', content:journeyData.coverLetter, picked:true}] : []
    const coverLetters = (journeyData.coverLetters&&journeyData.coverLetters.length>0 ? journeyData.coverLetters : defCoverLetters).map(coverLetter=>(coverLetter.picked && coverLetter.link && !coverLetter.content)?{...coverLetter, content:journeyData.coverLetter}:coverLetter)

    const haveCoverLetters = coverLetters.filter(coverLetter=>(!coverLetter.isDeleted)).length > 0

    const defDialogData = {open:false}
    const [dialogData, setDialogData] = useState((haveCoverLetters || !isApply) ? {open:false} : {open:true, editMode:true});
    const [changesDialog, setShowJourneyChanges] = useState({open:false});

    const getValue = (name, defaultValue) => {
        if (dialogData[name] !== undefined){
            return dialogData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeField = e => {
        setDialogData({...dialogData,[e.target.name]: e.target.value})
    };

    const handleChangeCoverLetter = newContent => {
        setDialogData({...dialogData,content: newContent})
    }

    const handleRestoreCL = newContent => {
        let paramsToPass = {coverLetter:{...dialogData, content: newContent}}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        props.preServerCall()

        JHApi.addEditCoverLetter(paramsToPass,(response)=>{
            setDialogData(defDialogData)
            props.postServerCall(null, response)
            setShowJourneyChanges({open:false})
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            setDialogData({...dialogData,error})
            props.postServerCall()
        })
    }

    const handleSave = e => {
        e.preventDefault();

        let paramsToPass = {coverLetter:dialogData}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        props.preServerCall()

        JHApi.addEditCoverLetter(paramsToPass,(response)=>{
            setDialogData(defDialogData)
            props.postServerCall(null, response)
        }, (error) => {
            if(error && error.response&& error.response.data){
                console.log(error.response.data)     
            } else {
                console.log(error)
            }

            setDialogData({...dialogData,error})
            props.postServerCall()
        })
    }

    const handlePickCL = (id) => {
        let fields = {goToNextStep:false}

        if (isApply){
            fields.coverLetters = coverLetters.map((coverLetter, index) => (index === id)?{...coverLetter, applyPicked:true}:{...coverLetter, applyPicked:false})
        } else {
            fields.coverLetters = coverLetters.map((coverLetter, index) => (index === id)?{...coverLetter, picked:true}:{...coverLetter, picked:false})
            fields.coverLetter = coverLetters[id].content
        }

        props.handleSaveData(fields,(response)=>{
            setDialogData(defDialogData)
            if (props.handlaeAfterSelect){
                props.handlaeAfterSelect()
            }
        }, (error) => {
            setDialogData({...dialogData,error})
        })
    }

    const handleCancel = () => {
        setDialogData(defDialogData)
    }

    const handleAddLink = () => {
        setDialogData({open:true, editMode:true})
    }

    const handleEditCoverLetter = () => {
        setDialogData({...dialogData, editMode:true})
    }

    const handleDeleteCoverLetter = (id, object) => () => {
        setDialogData({open:true, id, isDelete:true, editMode:true, ...object})
    }

    const handleShowChanges = () => {
        setShowJourneyChanges({
            open:true,
            id:dialogData.id,
            journeyId: journeyData._id
        })
    }

    const handleShowCL = (id, object, editMode=false) => () => {
        setDialogData({open:true, id, editMode, ...object})
    }

    const fields = [
        {name:'title', label:'Cover letter name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12},
    ]
    const fieldsLink = [
        {name:'link', label:'Link', defaultValue: '', type:FIELD_TYPES.TEXT, placeholder:'Example: https://docs.google.com/document/d/{id}/edit?usp=sharing&ouid={uid}&rtpof=true&sd=true', sm:12},
    ]

    return (
        <>
            <Dialog onClose={handleCancel} open={dialogData.open} maxWidth={dialogData.isDelete?'xs':'md'} fullWidth={!dialogData.isDelete}>
                {!dialogData.isDelete&&<DialogTitle>{dialogData.title||''}</DialogTitle>}
                {dialogData.editMode?<form onSubmit={handleSave}>
                    <DialogContent dividers style={dialogData.isDelete?{}:{minHeight:300}}>
                        {(dialogData.error)&&<Typography color="error">{dialogData.error}</Typography>}
                        {dialogData.isDelete?<Typography>Delete cover letter?</Typography>:<>
                        <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                        {dialogData.link&&<Fields fields={fieldsLink} getValue={getValue} handleChange={handleChangeField}/>}
                        <JSTextEdidor limitToolbar value={dialogData.content||''} onChange={handleChangeCoverLetter} isCoverLetters isActiveJHUser={props.isActiveJHUser}/>
                        </>}
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={handleCancel} color="primary" size="small" aria-label="Cancel">
                            {dialogData.isDelete?'No':'Cancel'}
                        </Button>
                        <Button
                            disabled={isLoading}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label='Save'
                        >
                            {dialogData.isDelete?'Yes':'Save'}
                        </Button>
                    </DialogActions>
                </form>:<>
                    <DialogContent dividers>
                        {dialogData.link&&<div><a href={dialogData.link} target="_blank" rel="noopener noreferrer">Link</a></div>}
                        <div dangerouslySetInnerHTML={{__html: dialogData.content}} />
                    </DialogContent>
                    <DialogActions>
                        {isAdmin&&<Button disabled={isLoading} onClick={handleShowChanges} color="primary" size="small" aria-label="Show Changes">
                            Show Changes
                        </Button>}
                        <Button disabled={isLoading} onClick={handleEditCoverLetter} color="primary" size="small" aria-label="Edit">
                            Edit
                        </Button>
                    </DialogActions>
                </>}
            </Dialog>

            <CoverLetterChanges handleRestoreCL={handleRestoreCL} changesDialog={changesDialog} setShowJourneyChanges={setShowJourneyChanges}/>

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, marginTop: 8}}>
                {(haveCoverLetters||!isApply)&&<Typography variant='h3' style={{fontSize: 18,lineHeight: '28px'}}>{isApply?'Select Cover Letter:':'Cover Letters'}</Typography>}
                <div>
                <Button
                    variant='contained'
                    disabled={isLoading}
                    onClick={handleAddLink}
                    color="primary"
                    style={{textTransform: 'capitalize', minWidth: 200, marginLeft: 16}}
                    startIcon={<AddIcon />}
                >
                    Add Cover Letter
                </Button>
                {!props.isActiveJHUser&&<Button onClick={()=>ReactGA.event({category: 'Journey', action: `generate_cover_letter_with_ai`})} startIcon={<SparklesIcon />} style={{textTransform: 'none', marginLeft: 8, boxShadow: 'none'}} variant='contained' color='primary' href="https://chatgpt.com/g/g-69c640b59c888191a286e991d47b288d-jobhunt-cover-letter-builder" target='_blank'>Generate with AI</Button>}
                </div>
            </div>

            {/*coverLetters.map((coverLetter, index) => <Fragment key={index}>
                {!coverLetter.isDeleted&&coverLetter.picked&&<div className={clsx(journeyClasses.cvclTag, coverLetter.picked&&journeyClasses.cvclTagActive)}>
                    <IconButton disabled={!isAdmin} aria-label="edit" onClick={()=>{if(!coverLetter.picked){handlePickCL(index)}}} size='small' style={{marginRight:4}} color='primary'>
                        {coverLetter.picked?<UnPickIcon fontSize="small" />:<PickIcon fontSize="small" />}
                    </IconButton>
                    <span style={{color: '#1861bf', cursor: 'pointer', textDecoration: 'underline'}} onClick={handleShowCL(index, coverLetter)}>{coverLetter.title}</span>
                    <div style={{flex:1}}></div>
                    {(isAdmin&&!coverLetter.picked)&&<IconButton aria-label="delete" onClick={handleDeleteCoverLetter(index, coverLetter)} size='small' style={{marginLeft:4}}>
                        <DeleteIcon/>
                    </IconButton>}
                </div>}
            </Fragment>)}
            {coverLetters.map((coverLetter, index) => <Fragment key={index}>
                {!coverLetter.isDeleted&&!coverLetter.picked&&<div className={clsx(journeyClasses.cvclTag, coverLetter.picked&&journeyClasses.cvclTagActive)}>
                    <IconButton disabled={!isAdmin} aria-label="edit" onClick={()=>{if(!coverLetter.picked){handlePickCL(index)}}} size='small' style={{marginRight:4}} color='primary'>
                        {coverLetter.picked?<UnPickIcon fontSize="small" />:<PickIcon fontSize="small" />}
                    </IconButton>
                    <span style={{color: '#1861bf', cursor: 'pointer', textDecoration: 'underline'}} onClick={handleShowCL(index, coverLetter)}>{coverLetter.title}</span>
                    <div style={{flex:1}}></div>
                    {(isAdmin&&!coverLetter.picked)&&<IconButton aria-label="delete" onClick={handleDeleteCoverLetter(index, coverLetter)} size='small' style={{marginLeft:4}}>
                        <DeleteIcon/>
                    </IconButton>}
                </div>}
            </Fragment>)*/}
            {coverLetters.map((coverLetter, index) => {
                const isSelected = isApply ? (coverLetter.applyPicked) : coverLetter.picked

                return (<Fragment key={index}>
                    {!coverLetter.isDeleted&&<div className={"tag"+(isSelected?" selected":"")} style={{display: 'inline-flex', fontSize: 15, alignItems: 'center', cursor: 'default'}}>
                        <IconButton disabled={!isAdmin && !isApply} aria-label="edit" onClick={()=>{if(!isSelected){handlePickCL(index)}}} size='small' style={{marginRight:4}} color='primary'>
                            {isSelected?<UnPickIcon fontSize="small" />:<PickIcon fontSize="small" />}
                        </IconButton>
                        <span style={{color: '#1861bf', cursor: 'pointer', textDecoration: 'underline'}} onClick={handleShowCL(index, coverLetter)}>{coverLetter.title}</span>
                        <IconButton aria-label="edit" onClick={handleShowCL(index, coverLetter, true)} size='small' style={{marginLeft:4}}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                        {(isAdmin&&!isSelected&&!coverLetter.picked)&&<IconButton aria-label="delete" onClick={handleDeleteCoverLetter(index, coverLetter)} size='small' style={{marginLeft:4}}>
                            <DeleteIcon/>
                        </IconButton>}
                    </div>}
                </Fragment>)
            })}
        </>
    )
}